import { useCallback, useMemo } from 'react'
import { FileWarning } from 'lucide-react'
import { PageHeader } from '@/shell/AppShell'
import { DataTable } from '@/components/DataTable'
import type { AdminColumn } from '@/components/DataTable/types'
import { PERMISSIONS } from '@/lib/permissions'
import { fetch404s, SEO_STR as S, type NotFoundRow } from './seoApi'

/**
 * A12.12 — Мониторинг 404. Most-hit missing paths + a fix suggestion. Dormant
 * until `/admin/seo/not-found` ships. Placeholder permission USERS_VIEW.
 */
export function NotFoundMonitorScreen() {
  const columns = useMemo<AdminColumn<NotFoundRow>[]>(
    () => [
      { key: 'path', header: S.path, type: 'text' },
      { key: 'hits', header: S.hits, type: 'number' },
      { key: 'last_seen', header: S.lastSeen, type: 'text' },
      { key: 'suggestion', header: S.suggestion, type: 'text' },
    ],
    [],
  )
  const fetcher = useCallback(fetch404s, [])
  return (
    <>
      <PageHeader title={S.notFound} screenId="A12.12" />
      <DataTable<NotFoundRow>
        screenId="A12.12"
        permission={PERMISSIONS.USERS_VIEW}
        columns={columns}
        fetcher={fetcher}
        rowId={(r) => r.path}
        exportable
        emptyState={{ icon: <FileWarning size={28} strokeWidth={1.5} /> }}
      />
    </>
  )
}
